interface Props {
  number: string;
  description: string;
  status: string;
  type: string;
  caller: string;
  coordinator: string;
}

const CustomerChange = ({
  number,
  description,
  status,
  type,
  caller,
  coordinator,
}: Props) => {
  return (
    <div className="w-full text-black border-b-2 border-gray-300 p-2 flex items-center text-sm hover:bg-gray-50">
        <p className="w-2/12">{number}</p>
        <p className="w-3/12">{description}</p>

        <p className="w-2/12 text-left">{status}</p>
        <p className="w-2/12 text-left">{type}</p>
        <div className="w-2/12 flex flex-col text-nowrap justify-center">
        <p>
          <b>Aanvrager:</b> {caller}
        </p>
        <p>
          <b>Coordinator:</b> {coordinator}
        </p>
      </div>
      </div>
    // <div className={containerClass}>
    //   <p className="w-1/12 text-center">{number}</p>
    //   <p className="w-3/12 text-left">{description}</p>
    //   <p className="w-2/12 text-center">{caller}</p>
    //   <p className="w-2/12 text-center">{status}</p>
    //   <p className="w-2/12 text-center">{coordinator}</p>
    //   <p className="w-2/12 text-center">{type}</p>
    // </div>
  );
};

export default CustomerChange;
